export default __webpack_public_path__ + "static/media/TL09.51994d0b.mp3";